import api from "./api";
import { Industry, Test } from "../types/industry";

export const getIndustry = (id: number) =>
  api.get<Industry>(`industries/${id}/`).then((r) => r.data);

export const listIndustries = () =>
  api.get<Industry[]>("industries/").then(r => r.data);

export const createIndustry = (body: { name: string; color_hex: string }) =>
  api.post<Industry>("industries/", body).then(r => r.data);

export const deleteIndustry = (id: number) =>
  api.delete(`/industries/${id}/`);

export const createTest = (body: any) =>
  api.post("/tests/", body).then(r => r.data);

export const getTest = (id: number) =>
  api.get<Test>(`tests/${id}/`).then((r) => r.data);

export const updateTest = (id: number, data: Partial<Test>) =>
  api.put<Test>(`tests/${id}/`, data).then((r) => r.data);
